import React from 'react'
import Head from 'next/head'
import FavIconLinks from './favicon-links'

const Favicon = () => {
  return (
    <Head>
      <FavIconLinks />
    </Head>
  )
}

export default Favicon
